import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BubbleSVG } from '../../components/BubbleSVG';
import { Content } from '../../components/Content';
import { WindowContext } from '../../providers';
import { media } from '../../services/media';
import { parseHTML } from '../../services/parseHTML';
import React, { useContext } from 'react';

interface ColumnProps {
    title: string;
    content: string;
    renderAsBubble: boolean;
}

export const Column: React.FC<ColumnProps> = ({
    content,
    renderAsBubble,
    title,
}) => {
    const { currentMediaName } = useContext(WindowContext);

    if (renderAsBubble) {
        return (
            <StyledColumn>
                <BubbleSVG
                    transition={false}
                    backgroundSvgName={
                        currentMediaName === 'desktop'
                            ? 'bubbleOmOssTopDesktop'
                            : 'bubbleOmOssTop'
                    }
                >
                    {title && <Heading>{title}</Heading>}
                    {content && (
                        <Content>{parseHTML(content, 'markdown')}</Content>
                    )}
                </BubbleSVG>
            </StyledColumn>
        );
    }

    return (
        <StyledColumn>
            {title && <Heading>{title}</Heading>}
            {content && <Content>{parseHTML(content, 'markdown')}</Content>}
        </StyledColumn>
    );
};

const Heading = styled.h2``;

const StyledColumnLeft = css`
    &:nth-of-type(1) {
        max-width: 100%;

        margin: 0 auto 32px;

        ${media.min('md')} {
            padding-top: 40px;
            padding-right: 20px;
        }

        ${media.min('xxl')} {
            padding-top: 150px;

            margin-right: 0;
        }
    }
`;

const StyledColumnRight = css`
    &:nth-of-type(2) {
        text-align: center;
        width: 100%;

        transform: translate(-10%);

        ${media.min('xl')} {
            transform: translate(-5%);
        }

        ${media.min('sm')} {
            transform: translate(0);
        }
    }
`;

const StyledColumn = styled.div`
    ${media.min('md')} {
    }

    ${media.min('xxl')} {
        margin-right: 0;
    }

    ${StyledColumnRight}
    ${StyledColumnLeft}
`;
